import { Auth } from 'aws-amplify'

const ATHENA_HERA_URL = process.env.VUE_APP_ATHENA_HERA_API_URL

async function getAuthHeaders() {
  const session = await Auth.currentSession()
  const token = session.getIdToken().getJwtToken()
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
}

function ensureJsonResponse(res) {
  const contentType = res.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    throw new Error(`Athena API returned non-JSON response (${contentType || 'no content-type'}). The API endpoint may not be deployed.`)
  }
}

async function athenaGet(path) {
  if (!ATHENA_HERA_URL) throw new Error('VUE_APP_ATHENA_HERA_API_URL is not configured')
  const headers = await getAuthHeaders()
  const res = await fetch(`${ATHENA_HERA_URL}${path}`, { headers })
  if (!res.ok) {
    const body = await res.text().catch(() => '')
    console.error(`[athenaGet] ${path} failed with status ${res.status}:`, body)
    throw new Error(`Athena API error: ${res.status}`)
  }
  ensureJsonResponse(res)
  return res.json()
}

async function athenaPut(path, body) {
  if (!ATHENA_HERA_URL) throw new Error('VUE_APP_ATHENA_HERA_API_URL is not configured')
  const headers = await getAuthHeaders()
  const res = await fetch(`${ATHENA_HERA_URL}${path}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(`Athena API error: ${res.status}`)
  ensureJsonResponse(res)
  return res.json()
}

export async function getTenantRoles() {
  const result = await athenaGet('/role-permission-locks/roles')
  return result.data
}

export async function getUserRoles(userId) {
  const result = await athenaGet(`/role-permission-locks/user-roles/${userId}`)
  return result.data
}

export async function setUserRoles(userId, roleIds) {
  return athenaPut(`/role-permission-locks/user-roles/${userId}`, { roleIds })
}

export async function getRolesWithLocks() {
  const result = await athenaGet('/role-permission-locks')
  return result.data
}

export async function setRoleLocks(roleId, locks) {
  return athenaPut(`/role-permission-locks/${roleId}`, { locks })
}

export async function getEffectiveLocksForUser(userId) {
  const result = await athenaGet(`/role-permission-locks/effective/${userId}`)
  return result.data
}

/**
 * HA-2797: Athena Daily Roster notes (Stand Up, General, Fleet) that mention a
 * record, for the Daily Roster Mentions card on the Associate / Vehicle pages.
 * @param {'associate'|'vehicle'} type
 * @param {string} id Associate (Staff) or Vehicle id
 * @returns {Promise<Array<{id: string, date: string, noteType: string, text: string}>>}
 */
export async function getDailyRosterMentions(type, id) {
  const params = new URLSearchParams({ type, id })
  const result = await athenaGet(`/daily-roster-mentions?${params.toString()}`)
  return result.data || []
}
